module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/home-audio-4888d023bdd55ef4ebe79e8f4ea0a429.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/home-audio.png
// module id = Usig
// module chunks = 12 16 18